module.exports = __webpack_public_path__ + "static/event-5-04b6fb67c40b4f13f1c7512f9868f022.mp4";